import React, {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react';
import * as Yup from 'yup';
import {toast} from 'react-toastify';
import {Link, useHistory} from 'react-router-dom';
import {Form} from '@unform/web';
import CryptoJS from 'crypto-js';

import CustomButton from '../../components/Form/Button';
import Input from '../../components/Form/Input';

import {login} from '../../services/Auth';

import {IconButton, InputAdornment} from "@material-ui/core";
import {MdOutlineLogin} from "react-icons/md";
import logo from "../../assets/img/logo.png";
import Copyright from "../../components/Copyright";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import {
  SignInWrapper,
  LoginCard,
  CardHeader,
  CardBody,
  FooterText,
  CopyrightContainer,
  FormWrapper,
  StyledFormWrapper
} from "./styles";

function SignIn() {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const history = useHistory();
  const [isLoadingAutoLogin, setLoadingAutoLogin] = useState(false);

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const autoLogin = useCallback(() => {
    async function initAutoLogin() {
      let username = localStorage.getItem('username');
      let password = localStorage.getItem('password');

      if (username && password) {
        username = CryptoJS.AES.decrypt(username, process.env.REACT_APP_CRYPTO_SECRET_KEY);
        username = username.toString(CryptoJS.enc.Utf8);

        password = CryptoJS.AES.decrypt(password, process.env.REACT_APP_CRYPTO_SECRET_KEY);
        password = password.toString(CryptoJS.enc.Utf8);

        const response = await login({
          username,
          password,
        });

        if (response && response.status === 200) {
          localStorage.setItem('@name', username);
          localStorage.setItem('@user_token', response.data.token);

          const redirectUrl = localStorage.getItem('redirectUrl');
          if (redirectUrl) {
            localStorage.removeItem('redirectUrl')
            history.push(redirectUrl);
          } else {
            history.push('/dashboard');
          }
        }
      }
      setLoadingAutoLogin(true);
    }
    initAutoLogin();
  }, [history]);

  useLayoutEffect(autoLogin, []);

  async function handleLogin(data) {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      formRef.current.setErrors({});
      const schema = Yup.object().shape({
        email: Yup.string()
            .email("Insira um e-mail válido")
            .required("O e-mail é obrigatório"),
        password: Yup.string().required("A senha é obrigatória")
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      const response = await login({
        username: data.email,
        password: data.password,
      });

      if (response && response.status === 200) {
        localStorage.setItem('@name', data.email);
        localStorage.setItem('userKey', data.email);
        localStorage.setItem('@user_token', response.data.token);

        const username = CryptoJS.AES.encrypt(data.email, process.env.REACT_APP_CRYPTO_SECRET_KEY).toString();
        const password = CryptoJS.AES.encrypt(data.password, process.env.REACT_APP_CRYPTO_SECRET_KEY).toString();

        localStorage.setItem('username', username);
        localStorage.setItem('password',password);

        toast.success("Login realizado com sucesso!");
        history.push('/dashboard');
      } else {
        toast.error("Credenciais inválidas!");
      }
      setLoading(false);
    } catch (err) {
      toast.error("Credenciais inválidas!");
      setLoading(false);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(async () => {
    if (localStorage.getItem('autoLogin')) {
      localStorage.removeItem('autoLogin');
      let data = null;
      try {
        data = await login({
          username: localStorage.getItem('username'),
          password: localStorage.getItem('socialId'),
        });
      } catch (err) {
      }

      if (data && data.status === 200) {
        localStorage.setItem('@user_token', data.data.token);
        toast.success("Login realizado com sucesso!");
        history.push('/dashboard');
      } else if (data) {
        toast.error("Credenciais inválidas!");
      }
    }
  }, []);

  return (
      <>
        {isLoadingAutoLogin && (
          <SignInWrapper>
            <div className="col-12 d-flex flex-column justify-content-center logo-sm pt-2 pt-md-4" style={{ position: 'relative', zIndex: 1, marginBottom: '1.5rem' }}>
              <Link to={"/"}>
                <img
                  alt={"Logo do sistema"}
                  src={logo}
                  style={{
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: '100%',
                    height: 'auto',
                    width: '120px'
                  }}
                  className="d-md-none"
                />
                <img
                  alt={"Logo do sistema"}
                  src={logo}
                  style={{
                    display: 'none',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: '100%',
                    height: 'auto',
                    width: '160px'
                  }}
                  className="d-none d-md-block"
                />
              </Link>
            </div>
            
            <LoginCard>
              <CardBody>
                <CardHeader>
                  <h1>
                    <i className="fas fa-sign-in-alt"/> Entre na sua conta
                  </h1>
                </CardHeader>
                
                <StyledFormWrapper>
                  <Form ref={formRef} onSubmit={handleLogin}>
                    <div className="row mb-4">
                      <div className="col-12">
                        <Input
                          type="text"
                          name="email"
                          label={"Informe seu e-mail"}
                        />
                      </div>
                    </div>
                    
                    <div className="row mb-4">
                      <div className="col-12">
                        <Input
                          name="password"
                          type={showPassword ? 'text' : 'password'}
                          label={"Informe sua senha"}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  onMouseUp={handleMouseUpPassword}
                                  edge="end"
                                  style={{ color: '#ffffff' }}
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                    
                    <div className="row mb-4">
                      <div className="col-12">
                        <CustomButton
                          startIcon={<MdOutlineLogin/>}
                          className="btn btn-primary text-capitalize font-weight-bold mobile-button"
                          loading={loading}
                          type="submit"
                          style={{
                            background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
                            border: 'none',
                            color: '#ffffff',
                            borderRadius: '8px',
                            fontWeight: 600,
                            width: '100%',
                            boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onMouseEnter={(e) => {
                            if (!loading) {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                          }}
                        >
                          Entrar
                        </CustomButton>
                      </div>
                    </div>
                    
                    {/*<FooterText>
                      Não tem uma conta?
                      <Link to="/register">
                        {' '}Cadastre-se
                      </Link>
                    </FooterText> */}
                  </Form>
                </StyledFormWrapper>
              </CardBody>
            </LoginCard>
            
            <CopyrightContainer>
              <Copyright/>
            </CopyrightContainer>
          </SignInWrapper>
        )}
      </>
  );
}

export default SignIn;
